import React from 'react';
import {connect} from 'react-redux';
import {
  Redirect,
  withRouter,
  Route
} from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import { hasAnyRoleNotExist, setPanelHeight } from "../actions/utils";
import { removeAllCache } from "../actions/actions";
import ReporterIndex from "../pages/Reporter/Home/index";
import GeneralStatusReport from '../pages/Reporter/GeneralStatusReport/list';
import DailyReport from '../pages/Reporter/DailyReport/list';
import ErrorCodeReport from '../pages/Reporter/ErrorCodeReport/list';
import InvoiceReport from '../pages/Reporter/InvoiceReport/list';
import ErrorCodeMsisdnReport from '../pages/Reporter/ErrorCodeMsisdnReport/list';

class ReporterLayout extends React.Component {
    constructor(props){
        super(props);
    }

    componentDidMount() {
        setPanelHeight();
        window.addEventListener('load', setPanelHeight);
        window.addEventListener('resize', setPanelHeight);
    }
    
    componentWillUnmount() {
        window.removeEventListener('resize', setPanelHeight);
    }

    componentDidUpdate(prevProps, prevState, snapshot)
    {
        setPanelHeight();
    }
    
    render() {
        if(localStorage.getItem('user') == null || hasAnyRoleNotExist("OmsgReport"))
        {
            localStorage.removeItem('user');
            localStorage.removeItem('userType');
            this.props.dispatch(removeAllCache());
            return (<Redirect
                        to={{
                            pathname: "/",
                            state: { from: this.props.location }
                        }}
                    />
              );
        }

        return (
            <div>
                <Header />
                <Route exact path="/omsg-report" component={ReporterIndex} />
                <Route exact path="/omsg-report/general" component={GeneralStatusReport} />
                <Route exact path="/omsg-report/daily" component={DailyReport} />
                <Route exact path="/omsg-report/error_code" component={ErrorCodeReport} />
                <Route exact path="/omsg-report/invoice" component={InvoiceReport} />
                <Route exact path="/omsg-report/error_msisdn_code" component={ErrorCodeMsisdnReport} />
                <Footer />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        app: state.app 
    }
}

export default withRouter(connect(mapStateToProps)(ReporterLayout))